import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/tipo_gasto/searchTipoEgresos.php';

export default function searchTipoEgresos({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}